module.exports = __webpack_public_path__ + "static/media/header-optimized.aa37c7bf.png";